/**
 * @file: 实名sdk弹窗
 * @author: v_shiying03
 */

import {createRoot, Root} from 'react-dom/client';
import IframeModal, {ENV_TYPE, InitialAuthType, SdkModalProps} from './IframeModal';

export interface QualifyModalSDKConfig {
    onSuccess?: () => void;
    onClose?: () => void;
    modalProps?: SdkModalProps;
    env?: ENV_TYPE;
    initialAuthType?: InitialAuthType;
}

class QualifyModalSDK {
    private container: HTMLElement | null = null;
    private root: Root | null = null;
    private config: QualifyModalSDKConfig = {};

    show(config: QualifyModalSDKConfig) {
        // 合并配置
        this.config = config;

        // 创建容器
        this.container = document.createElement('div');
        document.body.appendChild(this.container);

        // 渲染
        this.root = createRoot(this.container);
        this.render(true);
    }

    hide() {
        if (this.container) {
            this.render(false);
        }
    }

    destroy() {
        this.hide();
        if (this.root) {
            this.root.unmount();
            this.root = null;
        }

        if (this.container) {
            this.container.remove();
            this.container = null;
        }

    }

    private render(visible: boolean) {
        if (!this.root) {
            return;
        }

        this.root.render(
            <IframeModal
                visible={visible}
                onSuccess={() => {
                    this.config.onSuccess?.();
                    this.destroy();
                }}
                onClose={() => {
                    this.config.onClose?.();
                    this.destroy();
                }}
                env={this.config?.env}
                initialAuthType={this.config?.initialAuthType}
                modalProps={this.config?.modalProps}
            />
        );
    }
}

export default new QualifyModalSDK();
